export function getFiscalYears() {  
  const startYear = 2013
  let availableYears = [startYear]
  for (let i = 1; i <= 20; i++) 
    availableYears.push(startYear + i)
  
  return availableYears
}